import type { ItemActionProps, SampleReceipt } from '../../../common/types';
import SampleReceiptActionList from './SampleReceiptActionList';

const ListSampleReceiptItem: React.FC<ItemActionProps<SampleReceipt>> = ({ item, handleToggleActionModal }) => {
  return (
    <tr className="text-sm text-gray-700 odd:bg-white even:bg-gray-50 hover:bg-gray-300" key={item.id}>
      <td className="p-2 pl-8">
        <div className="flex flex-col">
          <span>{item.title}</span>
        </div>
      </td>
      <td className="p-2">{item.receipt.slice(0, 10) + '....'}</td>
      <td className="p-2">
        {item.ownerEntityType.toUpperCase()} - {item.ownerEntityId}
      </td>
      <td className="p-2 pr-8 text-left ">
        <div className="flex flex-row items-center justify-center space-x-2">
          <SampleReceiptActionList item={item} handleToggleActionModal={handleToggleActionModal} />
        </div>
      </td>
    </tr>
  );
};

export default ListSampleReceiptItem;
